import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const layoutStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      // backgroundColor: "#F6F7F9",
    },
  })
);

export const headerStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 100,
      width: "100%",
      maxWidth: "100vw",
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
      zIndex: 100,
      "@media (max-width: 600px)": {
        height: 100,
      },
    },
    whiteText: {
      color: "white",
      lineHeight: "1.2",
    },
    headerLeft: {
      height: "100%",
      minWidth: 550,
      backgroundColor: "#3E4066",
      borderRadius: "0 0 0 64px",
      padding: "12px 24px",
      "@media (min-width: 1200px)": {
        minWidth: 600,
      },
      "@media (min-width: 668px) and (max-width: 960px)": {
        minWidth: 350,
      },
      "@media (max-width: 668px)": {
        minWidth: 0,
        borderRadius: "0 0 0 64px",
        padding: "12px 16px",
      },
    },
    headerLeftContents: {
      height: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      marginLeft: 24,
      "@media (max-width: 668px)": {
        alignItems: "center",
        justifyContent: "flex-start",
      },
    },
    logoContainer: {
      marginRight: "24px",
      cursor: "pointer",
      "@media (max-width: 668px)": {
        display: "none",
      },
    },
    logoContainerMobile: {
      marginRight: "24px",
    },
    titleContainer: {
      "@media (max-width: 600px)": {
        display: "none",
      },
    },
    title: {
      fontWeight: "bold",
      fontSize: 24,
      fontStyle: "italic",
      maxHeight: "100%",
    },
    subtitle: {
      fontWeight: "lighter",
      fontSize: 34,
      marginBottom: 12,
      fontStyle: "italic",
    },
    welcome: {
      fontSize: 20,
      marginTop: 18,
    },
    headerRight: {
      height: 100,
      width: "100%",
      backgroundColor: "#3E4066",
      padding: "12px 24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    navRow: {
      height: "100%",
      "@media (max-width: 600px)": {
        display: "none",
      },
    },
    linksList: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      listStyle: "none",
      padding: 0,
      margin: 0,
      height: "100%",
    },
    linkButton: {
      color: "white !important",
      textTransform: "none !important" as any,
      fontSize: "18px !important",
      padding: "0 16px !important",
      "@media (min-width: 1500px)": {
        fontSize: "18px !important",
        padding: "0 16px !important",
      },
    },
    iconsRow: {},
    icon: {
      color: "white",
      fill: "white",
      transition: "transform 0.3s ease-in-out",
      "&:hover": {
        transform: "scale(1.15)",
      },
      "@media (min-width: 600px) and (max-width: 960px)": {
        fontSize: "48px !important",
      },
      "@media (max-width: 600px)": {
        fontSize: "48px !important",
      },
    },
    iconButton: {
      "@media (min-width: 600px) and (max-width: 960px)": {
        padding: "4px 4px",
      },
      "@media (max-width: 600px)": {
        padding: "4px 4px",
      },
    },
    iconButtonLoading: {
      height: "64px !important",
      width: 64,
      margin: 10,
      "@media (max-width: 600px)": {
        height: "48px !important",
        width: 48,
        margin: 4,
      },
    },
    iconSelected: {
      color: "#5db2e3",
      fill: "#5db2e3",
    },
    tooltip: {
      fontSize: "24px !important",
    },
    navigateTo: {
      color: "white",
      fontSize: 16,
      marginRight: 12,
      marginTop: 16,
      fontWeight: "bold",
      "@media (max-width: 800px)": {
        display: "none",
      },
    },
    inverseIcon: {
      color: "#3E4165",
      fill: "#3E4165",
      backgroundColor: "white",
    },
    menuIcon: {
      paddingLeft: 0,
      "@media (min-width: 600px)": {
        display: "none !important",
      },
    },
    mobileTitle: {
      display: "none !important",
    },
    dropDownMenu: {
      minWidth: "300px",
    },
    dropDownMenuItem: {
      minWidth: "150px",
      fontSize: "16px !important",
    },
    dropDownMenuIcon: {
      minWidth: "40px !important",
    },
    inline: {
      display: "inline",
    },
    notificationsList: {
      minWidth: "300px",
      maxWidth: "36ch",
      backgroundColor: theme.palette.background.paper,
    },
    notificationContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center",
    },
    notificationTitleContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
    },
    notificationTitle: {
      fontSize: "16px",
    },
    notificationDate: {
      fontSize: "13px",
    },
    notificationDescription: {
      width: "100%",
      marginBottom: 6,
      fontSize: "14px",
    },
    notificationLink: {
      width: "100%",
      textDecoration: "underline",
      fontSize: "14px",
      color: "#002655",
    },
    drawer: {
      width: 300,
      flexShrink: 0,
    },
    drawerPaper: {
      width: 300,
    },
    drawerContainer: {
      overflow: "auto",
    },
    drawerContent: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    drawerToolbar: {
      minHeight: "100px !important",
      backgroundColor: "#3E4066",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      borderRadius: "0 0 0 64px",
    },
    drawerListItem: {
      padding: "12px 24px 12px 24px !important",
    },
    drawerLink: {
      fontSize: "16px !important",
      fontWeight: "bold !important" as any,
      textDecoration: "none !important",
    },
    authHeader: {
      position: "fixed",
      zIndex: 100,
      margin: "0 auto 0 auto",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      backgroundColor: "white",
      padding: "12px 12px",
    },
    authHeaderWordMark: {
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    authHeaderLogoContainer: {
      position: "relative",
    },
    authHeaderTitle: {
      marginLeft: "16px !important",
    },
    blue: {
      color: "#5db2e3",
    },
    prepFqHeader: {
      zIndex: 100,
      margin: "0 auto 0 auto",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      backgroundColor: "white",
      padding: "24px 24px",
      "@media (max-width: 960px)": {
        padding: "12px 12px",
      },
      marginBottom: "24px",
    },
    prepFqTitle: {
      fontSize: "24px !important",
      marginTop: "12px !important",
    },
  })
);

export const bodyStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: "calc(100vh - 125px)",
      paddingBottom: 0,
      paddingTop: 0,
      display: "flex",
      flexDirection: "column",
      "@media (max-width: 600px)": {
        minHeight: "calc(100vh - 80px)",
      },
    },
    asipQuestionnaireRoot: {
      height: "100vh",
      paddingBottom: 0,
      paddingTop: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
  })
);

export const footerStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#182A53",
      borderRadius: "0 150px 0 0",
      marginRight: 8,
      padding: "96px 36px 48px 36px",
      zIndex: 10,
    },
    altRoot: {
      backgroundColor: "black",
      padding: "12px 36px 12px 36px",
      zIndex: 10,
    },
    content: {
      maxWidth: "1200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      margin: "0 auto",
    },
    divider: {
      height: "2px",
      width: "100%",
      backgroundColor: "#5db2e3",
      marginTop: "64px",
      marginBottom: "48px",
    },
    dividerAlt: {
      marginTop: 12,
      marginBottom: 12,
    },
    titleContainer: {
      height: "80px",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "flex-start",
      marginBottom: "40px",
    },
    titleContainerAlt1: {
      marginBottom: "24px",
    },
    titleContainerAlt2: {
      marginBottom: "16px",
    },
    paragraphContainer: {
      paddingRight: "48px",
    },
    paragraph: {
      color: "white",
      fontSize: "18px",
      lineHeight: "1.5",
    },
    title: {
      color: "#5db2e3",
      textTransform: "uppercase",
      fontSize: "22px",
      position: "relative",
      "&:after": {
        content: '""',
        position: "absolute",
        bottom: -4,
        left: 0,
        height: "0",
        width: "40px",
        borderBottom: "2px solid white",
      },
    },
    white: {
      color: "white",
    },
    linkContainer: {
      "@media (max-width: 600px)": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      },
    },
    linkContainerAlt: {
      margin: "0px 8px",
    },
    link: {
      color: "white !important",
      fontSize: "16px !important",
      paddingLeft: "0px !important",
      minWidth: "0 !important",
    },
    socialsList: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "row",
      padding: 0,
      margin: 0,
      listStyle: "none",
    },
    socialsListAlt: {
      alignItems: "center",
      justifyContent: "center",
    },
    socialsListItem: {
      listStyle: "none",
    },
    socialIcon: {
      color: "white !important",
      fontSize: "36px !important",
    },
    linkedInIcon: {
      color: "white !important",
      fontSize: "40px !important",
    },
    socialIconFirst: {
      paddingLeft: "0px !important",
    },
    socialMediaContents: {
      "@media (max-width: 600px)": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        marginTop: 36,
      },
    },
    linksContents: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      maxWidth: 600,
      marginTop: 36,
      "@media (max-width: 600px)": {
        alignItems: "center",
        justifyContent: "center",
      },
    },
    linksContentsAlt: {
      justifyContent: "center",
      maxWidth: 600,
      marginTop: 6,
    },
    copyrightContainer: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    copyRight: {
      color: "white",
      textTransform: "capitalize",
      fontSize: "12px",
    },
  })
);
